// Create React App inlines REACT_APP_* via process.env at build time
const env = process.env;

export function getFirebaseEnv() {
  return {
    apiKey: env.REACT_APP_FIREBASE_API_KEY || "",
    authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID || "",
    storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
    appId: env.REACT_APP_FIREBASE_APP_ID || "",
    measurementId:
      env.REACT_APP_FIREBASE_MEASUREMENT_ID ||
      env.REACT_APP_FIREBASE_MEASUREMENTID ||
      "",
  };
}

export function validateFirebaseEnv() {
  const config = getFirebaseEnv();
  const required = ["apiKey", "authDomain", "projectId", "appId"];
  const missing = required.filter((key) => !config[key]);
  return { ok: missing.length === 0, missing, config };
}

export function logEnvStatus(appName) {
  if (env.NODE_ENV !== "development") return;

  const fb = validateFirebaseEnv();
  console.group(`[${appName}] Environment (.env)`);
  console.log("Loaded from:", "process.env (CRA build-time)");
  console.log("Firebase project:", fb.config.projectId || "(missing)");
  console.log(
    "Firebase API key:",
    fb.config.apiKey ? `${fb.config.apiKey.slice(0, 10)}… (${fb.config.apiKey.length} chars)` : "(missing)"
  );
  console.log("Cloudinary cloud:", env.REACT_APP_CLD_CLOUD || "(missing)");
  console.log("Force host/blog mode:", env.REACT_APP_FORCE_HOST || "(not set)");
  console.log("Service status banner:", env.REACT_APP_SERVICE_STATUS || "(default by NODE_ENV)");
  if (!fb.ok) {
    console.warn("Missing Firebase env keys:", fb.missing.join(", "));
    console.warn("Fix host/.env and restart npm start.");
  }
  console.groupEnd();
}
